import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FaqSectionComponent from './FaqSectionComponent';
import BiographySection from './BiographySection';
import VideoSectionComponent from './VideoSectionComponent';
import NowellonEditableFieldPropType from "../NowellonEditableField/NowellonEditableFieldPropType";
import Picture from '../Shared/Picture';
// import NowellonEditableField from "../NowellonEditableField";
import ShareBox from 'Shared/ShareBox';
import ArticleBanner from 'Articles/ArticleBanner';
import ArticleBox from 'Articles/ArticleBox';
import CustomersAlsoLiked from 'ProductPageRestructure/RelatedContent';
import DiscoverMore from 'ProductPageRestructure/DiscoverMoreTreatments';

class Expert extends Component {
    constructor(props) {
        super(props);

        this.state = {
            "ActiveTab": this.getVal(this.props.ActiveTab, "faq"),
            "isMobile": window.innerWidth < 768,
            "isDesktop": window.innerWidth >= 1025
        };
    }

    setActiveSection = (section) => {
        let selectedSection = section.toLowerCase();
        const correctSections = ["faq", "video", "biography"];
        const isSectionCorrect = correctSections.indexOf(selectedSection) !== -1;
        selectedSection = isSectionCorrect ? selectedSection : correctSections[0];
        this.setState({
            ActiveTab: selectedSection
        })
    }
    toogleActiveAcordionTab = (evt) => {
        const className = "active";
        const element = evt.target;

        if (element) {
            const sibling = element.nextElementSibling;

            element.classList.toggle(className);

            if (sibling) {
                element.nextElementSibling.classList.toggle(className);
            }
        }
    }
    getVal = (nowellonObject, defValue) => {
        if (nowellonObject && typeof nowellonObject === 'object') {
            return nowellonObject.Value;
        }
        return defValue || "";
    }
    componentDidMount() {
        window.addEventListener('resize', this.checkWindowWidth);
    }
    checkWindowWidth = () => {
        this.setState({
            "isMobile": window.innerWidth < 768,
            "isDesktop": window.innerWidth >= 1025
        })
    }
    render() {
        let getVal = this.getVal;
        const {
            WatchVideoText,
            DoctorFullName,
            DoctorImageAlt,
            DoctorImageUrl,
            DoctorSpecialization,
            PageDescription,
            PageTitle,
            VideosText,
            FaqText,
            BiographyText,
            FaqSection,
            VideoSection,
            Biography,
            index,
            MetaPageTitle,
            MetaPageDescription,
            RelatedContent,
            DiscoverMoreTreatments
        } = this.props;

        return (
            <ul className="experts">
                <li className="expert">
                    <div className="expert-person clearfix">
                        <Picture src={DoctorImageUrl.Value} alt={DoctorImageAlt.Value} className="expert-pic" />
                        <h2 className="expert-name">
                            <strong>{getVal(DoctorFullName)}</strong>
                            <span>{getVal(DoctorSpecialization)}</span>
                        </h2>
                    </div>
                    <div className="expert-content">
                        <ul className="expert-tabs">
                            {getVal(FaqText) !== "" && (
                                <li
                                    className={this.state.ActiveTab === "faq" ? "active" : ""}
                                    onClick={() => this.setActiveSection("faq")}
                                >
                                    <span>{getVal(FaqText)}</span>
                                </li>
                            )}
                            {getVal(VideosText) !== "" && (
                                <li
                                    className={this.state.ActiveTab === "video" ? "active" : ""}
                                    onClick={() => this.setActiveSection("video")}
                                >
                                    <span>{getVal(VideosText)}</span>
                                </li>
                            )}
                            {getVal(BiographyText) !== "" && (
                                <li
                                    className={this.state.ActiveTab === "biography" ? "active" : ""}
                                    onClick={() => this.setActiveSection("biography")}
                                >
                                    <span>{getVal(BiographyText)}</span>
                                </li>
                            )}
                        </ul>
                        {this.state.ActiveTab === "faq" && FaqSection.length && (
                            <FaqSectionComponent
                                FaqSection={FaqSection}
                                toogleActiveAcordionTab={this.toogleActiveAcordionTab}
                                getVal={this.getVal}
                            />
                        )}
                        {this.state.ActiveTab === "video" && VideoSection.length && (
                            <VideoSectionComponent
                                VideoSection={VideoSection}
                                WatchVideoText={WatchVideoText}
                                getVal={this.getVal}
                                expertIndex={index}
                            />
                        )}
                        {this.state.ActiveTab === "biography" && getVal(Biography).length && (
                            <BiographySection
                                biography={Biography}
                                getVal={this.getVal}
                            />
                        )}
                        {DiscoverMoreTreatments.length > 0 && (
                            <DiscoverMore {...DiscoverMoreTreatments[0]} isDesktop={this.state.isDesktop} />
                        )}
                        {RelatedContent.length > 0 && (
                            <CustomersAlsoLiked
                                {...RelatedContent[0]}
                                isMobile={this.state.isMobile}
                            />
                        )}
                        {this.props.singleExpertPage && (
                            <ShareBox
                                MetaPageTitle={MetaPageTitle}
                                MetaPageDescription={MetaPageDescription}
                                lang={this.props.lang}
                            />
                        )}
                        {this.props.singleExpertPage && this.props.ArticleBanner && (
                            <ArticleBanner banner={this.props.ArticleBanner} />
                        )}
                        {this.props.singleExpertPage && this.props.ArticleBoxesTitle && this.props.ArticleBoxesTitle.Value !== "" ? (
                            <h2 className="informational-boxes-title">{this.props.ArticleBoxesTitle.Value}</h2>
                        ) : null}
                        {this.props.singleExpertPage && (
                            <div className="main informational-boxes">
                                {this.props.ArticleBoxes ? this.props.ArticleBoxes.map((box, id) => (
                                    <ArticleBox key={id} box={box} />
                                )) : null}
                            </div>
                        )}
                    </div>
                </li>
            </ul>
        )
    }
}
Expert.propTypes = {
    toogleActiveAcordionTab: NowellonEditableFieldPropType.isRequired,
    WatchVideoText: NowellonEditableFieldPropType.isRequired,
    ActiveTab: NowellonEditableFieldPropType.isRequired,
    DoctorFullName: NowellonEditableFieldPropType.isRequired,
    DoctorImageAlt: NowellonEditableFieldPropType.isRequired,
    DoctorImageUrl: NowellonEditableFieldPropType.isRequired,
    DoctorSpecialization: NowellonEditableFieldPropType.isRequired,
    FaqSection: PropTypes.array.isRequired,
    FaqText: NowellonEditableFieldPropType.isRequired,
    VideosText: NowellonEditableFieldPropType.isRequired,
    BiographyText: NowellonEditableFieldPropType.isRequired,
    Biography: NowellonEditableFieldPropType.isRequired,
    VideoSection: PropTypes.array.isRequired,
    index: PropTypes.string.isRequired
}
export default Expert;
